import { NgModule, ModuleWithProviders, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { SplitterModule } from './components/splitter/splitter';
import { IdeTabsModule } from './components/tabs/ide-tabs.module';
import { PanelFrameModule } from './components/panel-frame/panel-frame';
import { TreeModule } from './components/tree/tree';
import { SwitchButtonModule } from './components/switch-button/switch-button';

import { EventBusHandler } from './event-bus/handler';
import { ContextService } from './services/context.service';
import { RelevantFileService } from './services/relevant-file.service';
import { EditorController } from './controller/editor.controller';

import { CodeViewComponent } from './views/code-view.component';
import { PlaceholderComponent } from './views/center-panel/placeholder/placeholder.component';
import { CenterPanelComponent } from './views/center-panel/center-panel.component';
import { NAV_PANEL_COMPONENTS, NAV_PANEL_ENTRY_COMPONENTS, NAV_PANEL_PROVIDERS } from './views/nav-panel/panels';
import { DEFAULT_NAV_PANEL_SERVICES } from './nav-data/providers';

import { IDE_CODE_VIEW_CONFIG, IdeCodeViewConfig } from './config/global.config';

import { PresetConfigService } from './services/preset-config.service';
import { NavTreeService } from './services/nav-tree.service';
import { TabContextMenuService } from './services/tab-menu.service';

import { GSPMetadataServiceModule, MetadataSelectModule } from '@gsp-lcm/metadata-selector';
import { FarrisCommonModule } from "@farris/ui-common";
import { MessagerModule } from "@farris/ui-messager";
import { NotifyModule } from '@farris/ui-notify';
import { LocaleModule, LocaleService } from '@farris/ui-locale';
import { CODE_VIEW_DESIGNER_LOCALE } from './utils/locale';
@NgModule({
  declarations: [
    CodeViewComponent,
    PlaceholderComponent,
    CenterPanelComponent,
    NAV_PANEL_COMPONENTS
  ],
  imports: [
    FormsModule,
    CommonModule,
    HttpClientModule,
    SplitterModule,
    IdeTabsModule,
    PanelFrameModule,
    TreeModule,
    SwitchButtonModule,
    MessagerModule.forRoot(),
    NotifyModule,
    GSPMetadataServiceModule.forRoot(''),
    MetadataSelectModule,
    FarrisCommonModule,
    LocaleModule
  ],
  exports: [
    CodeViewComponent
  ],
  providers: [
    ContextService,
    RelevantFileService,
    EventBusHandler,
    EditorController,
    NavTreeService,
    TabContextMenuService,
    DEFAULT_NAV_PANEL_SERVICES,
    NAV_PANEL_PROVIDERS,
    PresetConfigService,
    { provide: LOCALE_ID, useValue: localStorage.getItem('languageCode') || 'zh-CHS' }
  ],
  bootstrap: [
    CodeViewComponent
  ],
  entryComponents: [
    NAV_PANEL_ENTRY_COMPONENTS
  ]
})
export class IdeCodeViewModule {
  constructor(private localeService: LocaleService) {
    if( this.localeService) {
      this.localeService.setLocaleData(CODE_VIEW_DESIGNER_LOCALE)

    }

}
  public static forRoot(config: IdeCodeViewConfig = {}): ModuleWithProviders {
    return {
      ngModule: IdeCodeViewModule,
      providers: [
        { provide: IDE_CODE_VIEW_CONFIG, useValue: config }
      ]
    };
  }

}
